import { render } from "./BasicInput.vue?vue&type=template&id=3f16ce20&scoped=true&ts=true"
import script from "./BasicInput.vue?vue&type=script&lang=ts"
export * from "./BasicInput.vue?vue&type=script&lang=ts"

import "./BasicInput.vue?vue&type=style&index=0&id=3f16ce20&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f16ce20"]])

export default __exports__